import { useState } from 'react';
import { telemetryAPI } from '../api/client';
import { captureEvent } from '../lib/posthog';

const STORAGE_KEY = 'clawer_data_nudge_dismissed';

export function DataSharingNudge() {
  const [dismissed, setDismissed] = useState(
    () => localStorage.getItem(STORAGE_KEY) === 'true'
  );
  const [saving, setSaving] = useState(false);
  const [opted, setOpted] = useState(false);

  if (dismissed || opted) {
    return null;
  }

  async function handleOptIn() {
    setSaving(true);
    try {
      await telemetryAPI.updateConfig(2);
      captureEvent('data_sharing_nudge_opted_in', { tier: 2 });
      setOpted(true);
      localStorage.setItem(STORAGE_KEY, 'true');
    } catch {
      // fail silently — they can configure in Settings
    } finally {
      setSaving(false);
    }
  }

  function handleDismiss() {
    captureEvent('data_sharing_nudge_dismissed', {});
    localStorage.setItem(STORAGE_KEY, 'true');
    setDismissed(true);
  }

  return (
    <div className="rounded-xl border border-accent/20 bg-accent-bg/50 p-4 mb-3">
      <div className="flex items-start gap-3">
        <div className="w-9 h-9 rounded-xl bg-white flex items-center justify-center flex-shrink-0">
          <span className="material-icons-round text-accent text-lg">favorite</span>
        </div>
        <div className="flex-1">
          <p className="text-sm font-semibold text-ink" data-ph-no-mask>
            Help make Clawer better for everyone
          </p>
          <p className="text-xs text-ink-secondary mt-1 leading-relaxed" data-ph-no-mask>
            Share anonymous usage data and AI performance stats so we can keep improving.
            Names and phone numbers are always removed.
          </p>
          <div className="flex items-center gap-3 mt-3">
            <button
              onClick={() => void handleOptIn()}
              disabled={saving}
              className="px-3 py-1.5 rounded-lg bg-accent text-white text-xs font-medium hover:bg-accent-deep transition-colors disabled:opacity-50"
              data-ph-no-mask
            >
              {saving ? 'Enabling...' : 'Sure, count me in'}
            </button>
            <button
              onClick={handleDismiss}
              className="text-xs text-ink-tertiary hover:text-ink-secondary transition-colors"
              data-ph-no-mask
            >
              Not now
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
